/* global triggerOmnitureInteractions */
import _ from 'lodash';
import * as d3 from 'd3';
import moment from 'moment';
import helper from '../../../helper';

// import helper from '../../../helper';

/* eslint no-shadow: ["error", {"allow": ["getters"]}] */
const getters = {
  indicatorsCsv: state => _(state.indicators).map('id').value().join(','),
  allPossibleIndicators: (state, getters, rootState) => _(rootState.spgsLink).filter({
    l: state.GSGo.locationId,
    c: state.GSGo.categoryId,
  }).map('q').uniq()
    .map(id => rootState.lku.Question[id])
    .orderBy('sort', 'asc')
    .value(),
  setBrowserUrlBarToReflectCurrentSPState: (state, getters, rootState) => (router) => {
    const panelsObjForQS = _(state.panels).reduce(
      (acc, value, key) => {
        /* example value => {
          "view": "Chart",
          "allYears": false,
          "yearId": "YR4",
          "stratCatId1": "DISSTAT",
          "stratId1": "",
          "stratCatId2": "",
          "stratId2": "",
          "responseId": "",
          "dataValueTypeId": "AGEADJPREV",
        } */

        // convert to csv list of values in the same order (keys implied by order)
        // pnl0: Chart,false,YR4,DISSTAT,,,,,AGEADJPREV
        acc[`pnl${key}`] = _(value).map(val => val).value().join(',');
        return acc;
      }
      , {},
    );
    const showDebugOption = {};
    if (rootState.flags.showDebugIds) showDebugOption.showDebugIds = rootState.flags.showDebugIds;
    // update the browser's url to reflect the current global selector, indicators, and panel state
    // example 371 characters: http://localhost:8080/SP?LocationId=08&CategoryId=HLTHRB&IndicatorIds=BINGE,BMI,SMOKE,QUITSMK,ECIG,TESTEVER&pnl0=Chart,false,YR4,DISSTAT,,,,,AGEADJPREV&pnl1=Chart,false,YR4,DISSTAT,,,,,AGEADJPREV&pnl2=Chart,false,YR4,DISSTAT,,,,,AGEADJPREV&pnl3=Chart,false,YR4,DISSTAT,,,,,AGEADJPREV&pnl4=Chart,false,YR4,DISSTAT,,,,,AGEADJPREV&pnl5=Chart,false,YR4,DISSTAT,,,,,AGEADJPREV
    // example 368 characters: http://localhost:8080/SP?LocationId=08&CategoryId=PREVENT&IndicatorIds=MAM2YR,UTDCERV,UTDCRC,PHYSICAL,DENTIST,FLUVAC&pnl0=Chart,false,YR4,DISSTAT,,,,,PREV&pnl1=Chart,false,YR4,DISSTAT,DISABL,,,,PREV&pnl2=Chart,false,YR4,DISSTAT,,,,,PREV&pnl3=Chart,false,YR4,DISSTAT,,,,,AGEADJPREV&pnl4=Chart,false,YR4,DISSTAT,,,,,AGEADJPREV&pnl5=Chart,false,YR4,DISSTAT,,,,,AGEADJPREV
    router.replace({
      path: '/SP',
      query: {
        LocationId: state.GSGo.locationId,
        CategoryId: state.GSGo.categoryId,
        ShowFootnotes: state.flags.showFootnotes,
        showMode: rootState.flags.showMode,
        IndicatorIds: _(state.indicators).map('id').value().join(','),
        ...panelsObjForQS,
        ...showDebugOption,
        t: new Date().getTime(),
      },
    });
  },
  csvExport: (state, getters, rootState) => (instance, filteredData, multistrat) => {
    const panel = state.panels[instance];
    const { lku } = rootState;
    const { locationId } = state.GSGo;

    let dataRows = filteredData.slice();
    dataRows = _(dataRows).map((d) => {
      let StratificationCategory1;
      let StratificationCategory2 = '';
      let Stratification1;
      let Stratification2 = '';
      switch (multistrat) {
        case '1':
          StratificationCategory1 = lku.StratificationCategory[d.sc1].name;
          Stratification1 = lku.Stratification[d.s1].name;
          break;
        case '12':
          StratificationCategory1 = lku.StratificationCategory[d.sc1].name;
          Stratification1 = lku.Stratification[d.s1].name;
          StratificationCategory2 = lku.StratificationCategory[d.sc2].name;
          Stratification2 = lku.Stratification[d.s2].name;
          break;
        case '21':
          StratificationCategory1 = lku.StratificationCategory[d.sc2].name;
          Stratification1 = lku.Stratification[d.s2].name;
          StratificationCategory2 = lku.StratificationCategory[d.sc1].name;
          Stratification2 = lku.Stratification[d.s1].name;
          break;
        default:
          throw new Error(`Unexpected multistrat value: ${multistrat}`);
      }
      const year = lku.Year[d.yr].name;
      return {
        YearStart: year.substr(0, 4),
        YearEnd: year.length === 9 ? year.substr(5, 4) : year.substr(0, 4),
        LocationAbbr: lku.Location[locationId].abbr,
        LocationDesc: lku.Location[locationId].name,
        DataSource: 'BRFSS',
        Category: state.GSGo.category,
        Question: state.indicators[instance].name,
        Response: lku.Response[d.rs].name,
        Data_Value_Unit: rootState.dataTypes[panel.dataValueTypeId].dataValueUnit,
        Data_Value_Type: rootState.dataTypes[panel.dataValueTypeId].dataValueType,
        Data_Value: d.dv,
        Data_Value_Footnote_Symbol: d.fn,
        Data_Value_Footnote: d.fn ? _(rootState.footnotes).filter({ fs: d.fn, type: 'Footnote' }).value()[0].ft : '',
        Low_Confidence_Limit: d.lci,
        High_Confidence_Limit: d.hci,
        WeightedNumber: d.wn,
        StratificationCategory1,
        Stratification1,
        StratificationCategory2,
        Stratification2,
      };
    }).value();

    const footnotes = _(rootState.footnotes)
      .filter(f => (f.type === 'MeasureDefinitions')
      || (f.type === 'GlobalNote')
      || (f.type === 'RelatedLinks')
      || (f.type === 'SuggestedCitation')
      || (f.type === 'IndicatorDefinition' && f.qc === state.indicators[instance].id))
      .orderBy(['type', 'sort'])
      .map(d => ({
        FootnoteText: d.type === 'SuggestedCitation' ? `${d.ft} [accessed ${moment().format('MMM D, YYYY')}]` : d.ft,
        Url: d.url ? helper.convertRelativeUrlToWCMSUrl(d.url) : '',
        FootnoteType: d.type,
      }))
      .value();

    return d3.csvFormat(dataRows.concat(footnotes));
  },
  triggerPanelInteraction: (state, getters, rootState) => (instance, interactionType) => {
    // console.log('triggerPanelInteraction', instance, interactionType, rootState.flags.initialPageLoad);
    const { locationId, categoryId } = state.GSGo;
    const indicatorId = state.indicators[instance].id;
    const panel = state.panels[instance];
    const view = panel.view.substr(0, 1);
    const year = panel.allYears ? '9999' : rootState.lku.Year[panel.yearId].name;
    const {
      stratCatId1, stratCatId2,
    } = panel;
    let {
      stratId1, stratId2, responseId,
    } = panel;
    const footnotes = state.flags.showFootnotes ? 'Y' : 'N';
    stratId1 = stratId1 || 'All';
    stratId2 = stratCatId2 && stratId2 === '' ? 'All' : stratId2;
    responseId = responseId || 'All';

    const { InteractionIdentifier } = process.env;

    switch (interactionType) {
      case 'LV':
        triggerOmnitureInteractions(`${InteractionIdentifier}-LV ${view},${locationId},${categoryId},${indicatorId},${year},${stratCatId1},${stratId1},${stratCatId2},${stratId2},${responseId}`);
        break;
      case 'LY':
        triggerOmnitureInteractions(`${InteractionIdentifier}-LY ${year},${locationId},${categoryId},${indicatorId},${view},${stratCatId1},${stratId1},${stratCatId2},${stratId2},${responseId}`);
        break;
      case 'LST':
        triggerOmnitureInteractions(`${InteractionIdentifier}-LST ${stratCatId1},${stratId1},${stratCatId2},${stratId2},${locationId},${categoryId},${indicatorId},${view},${year},${responseId}`);
        break;
      case 'LR':
        triggerOmnitureInteractions(`${InteractionIdentifier}-LR ${responseId},${locationId},${categoryId},${indicatorId},${view},${year},${stratCatId1},${stratId1},${stratCatId2},${stratId2}`);
        break;
      case 'LE PDF':
      case 'LE EX':
        triggerOmnitureInteractions(`${InteractionIdentifier}-${interactionType},${footnotes},${locationId},${categoryId},${indicatorId},${view},${year},${stratCatId1},${stratId1},${stratCatId2},${stratId2},${responseId}`);
        break;
      default:
        throw new Error(`Unexpected interactionType: ${interactionType}`);
    }
  },
  useDoubleWidePanels: state =>
  // double wide for Disability Estimates or Demograpics categories
    state.GSGo.categoryId === 'DISEST' || state.GSGo.categoryId === 'DEMOG'
  ,
};


export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/SP/getters.js